import { Box, Dialog, Typography, useMediaQuery, useTheme } from '@mui/material'
import ActionButtons from 'components/action-buttons/action-buttons.component'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import {
  useDeleteDriverMutation,
  useListDriversQuery,
} from 'store/drivers/drivers.api'
import { getUserId } from 'utils/common'

import { Driver } from 'store/drivers/drivers.type'

type Props = {
  open: boolean
  handleClose: () => void
  driver?: Driver
}

const DriverDeleteDialog = ({ open, handleClose, driver }: Props) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const userId = getUserId()

  const [deleteDriver] = useDeleteDriverMutation()
  const { refetch } = useListDriversQuery({ userId }, { skip: !userId })

  const selectedDriver = useSelector(
    (state: RootState) => state.drivers.selectedDriver
  )
  const driverToDelete = driver ?? selectedDriver

  const handleCancel = () => {
    handleClose()
  }

  const handleDelete = async () => {
    if (!driverToDelete?.id) return

    try {
      await deleteDriver(driverToDelete.id).unwrap()
      handleClose()
      refetch()
    } catch (error) {
      console.error('Error while deleting driver', error)
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <Box textAlign="center">
        <Typography fontWeight={700} px={1} py={4}>
          Are you sure you want to delete the driver?
        </Typography>
        <ActionButtons
          firstBtnProps={{
            title: 'Cancel',
            onClick: handleCancel,
            bgcolor: 'secondary.main',
          }}
          secondBtnProps={{ title: 'Delete', onClick: handleDelete }}
        />
      </Box>
    </Dialog>
  )
}

export default DriverDeleteDialog
